module.exports = "<p>\r\n  pipe-time works!\r\n</p>\r\n"